/**
 * Langues du site de gestion : celles du site public (textes partagés chargés par @web/i18n),
 * plus l'espace de noms « gestion » propre à ce site.
 * gestion.trouvetonrefuge.com → français, manage.findyourhut.com → anglais ; ailleurs, la détection du site.
 */
import i18n, { detectLanguage, initI18n } from '@web/i18n'
import fr from './locales/fr.json'
import en from './locales/en.json'

const HOST_LANG: Record<string, string> = {
  'gestion.trouvetonrefuge.com': 'fr',
  'manage.findyourhut.com': 'en',
}

function languageForHost(): string {
  const host = window.location.hostname.toLowerCase()
  const fromUrl = new URLSearchParams(window.location.search).get('lang')
  return HOST_LANG[host] && !fromUrl ? HOST_LANG[host] : detectLanguage()
}

export async function initGestionI18n() {
  await initI18n(languageForHost())
  i18n.addResourceBundle('fr', 'gestion', fr, true, true)
  i18n.addResourceBundle('en', 'gestion', en, true, true)
  document.title = i18n.t('gestion:app.titre')
}
